import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { SharedService } from '../shared/services/shared.service';
import { constants } from '../constants';
import { LOADER_TOKEN } from '../tokens/http-context.token';
import { environments } from '../../environments/env.production';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private sharedService = inject(SharedService);
  private apiRequestCount: number = 0;
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const loader = req.context.get(LOADER_TOKEN);
    this.sharedService.showLoader(loader);
    this.apiRequestCount++;

    // const email = localStorage.getItem(constants.authenticatedKey);

    let authReq = req.clone();
    // if (email) {
    if (req.url.includes(environments.secondaryUrl))
      authReq = req.clone({
        setHeaders: {
          // 'user-email': 'admin@gmail.com',
          'ngrok-skip-browser-warning': 'sadfsd',
        },
      });
    // }
    return next.handle(authReq).pipe(
      finalize(() => {
        this.apiRequestCount--;
        if (this.apiRequestCount === 0) this.sharedService.hideLoader(loader);
      })
    );
  }
}
